import styled from "styled-components";
import {
  ACCENT_PRIMARY_LIGHTEST,
  BRAND,
  TEXT_PRIMARY,
  WHITE
} from "@streeteasy/design-system/colors";

import { largeScreen } from "src/shared/constants/screenSizes";

const goatGrey = "#A1A1A1";
const whaleGrey = "#1A1F2C";

export const MostViewedListingWrapper = styled.div``;

export const ImageBox = styled.div`
  float: left;
  margin-right: 30px;
  width: 300px;
`;

export const ImageLink = styled.a``;
export const Link = styled.a``;

export const Image = styled.img`
  height: 250px;
  width: 300px;
`;

export const Content = styled.div`
  display: inline-block;
  height: 245px;
  position: relative;
  width: 38%;
`;

export const TitleLink = styled.a`
  color: ${BRAND};
  display: inline-block;
  font-size: 18px;
  line-height: 20px;
  margin-bottom: 13px;
`;

export const Bullet = styled.span`
  color: ${goatGrey};
  padding: 0 7px;
`;

export const Price = styled.span`
  font-size: 16px;
`;

export const For = styled.span`
  color: ${goatGrey};
  font-size: 12px;
  font-weight: 700;
  margin-left: 8px;
  text-transform: uppercase;
`;

export const Featured = styled.div`
  background: ${whaleGrey};
  color: ${WHITE};
  display: inline-block;
  font-size: 12px;
  font-weight: 700;
  margin-top: 13px;
  padding: 1px 7px 0;
  text-transform: uppercase;
`;

export const ListedBy = styled.div`
  bottom: 0;
  color: ${goatGrey};
  font-size: 12px;
  position: absolute;
`;

export const NoFeeBadge = styled.span`
  align-self: center;
  background-color: ${ACCENT_PRIMARY_LIGHTEST};
  border-radius: 100px;
  color: ${TEXT_PRIMARY};
  display: inline-block;
  font-size: 12px;
  font-weight: bold;
  height: 23px;
  justify-content: center;
  line-height: 23px;
  margin: 12px 4px 0;
  min-width: 55px;
  padding: 0 8px;
  text-transform: uppercase;

  @media screen and (max-width: ${largeScreen}px) {
    margin: 5px 4px 4px;
  }
`;
